import { styled } from '@mui/system'
import { Paper, Typography } from '@mui/material'

export const ProfilePageMain = styled('main')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 'calc(100vh - 5rem - 5rem)',
  padding: '1.6rem',
  background: 'rgba(0,0,0,0.05)',
}))

export const ProfilePageCard = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: '34rem',
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  boxShadow: '0 0.75rem 2.5rem rgba(0, 0, 0, 0.12)',
  [theme.breakpoints.down('sm')]: {
    padding: '1.2rem',
  },
}))

export const ProfilePageTitle = styled(Typography)(() => ({
  textAlign: 'center',
  fontWeight: 600,
}))

export const ProfilePageDescription = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.text.secondary,
  marginBottom: '0.5rem',
}))

export const ProfilePageForm = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}))

export const ProfilePageHint = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
  lineHeight: 1.5,
}))

export const ProfilePageDangerZone = styled('div')(({ theme }) => ({
  marginTop: '2rem',
  paddingTop: '1.5rem',
  borderTop: `2px solid ${theme.palette.error.light}`,
}))

export const ProfilePageDangerTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 600,
  marginBottom: '0.5rem',
}))

export const ProfilePageDangerDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
  marginBottom: '1rem',
}))

export const ProfilePageUserInfoSection = styled('div')(({ theme }) => ({
  paddingBottom: '1rem',
  marginBottom: '1rem',
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export const ProfilePageUsername = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
  marginBottom: '0.25rem',
}))

export const ProfilePageUsernameValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.25rem',
  color: theme.palette.text.primary,
}))